import React from "react";
import PropTypes from "prop-types";
import { Button, Text } from "@fluentui/react-components";
import { Checkmark20Filled } from "@fluentui/react-icons";
import { FormattedMessage } from "react-intl";
import { Modal } from "../modal/Modal";

export const RegistrationConfirmedDialog = ({ open, onClose, eventName, userEmail, startsInText, onJoin }) => {
  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      onClose={onClose}
      title={
        <div data-tracking="rsvp-success" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Checkmark20Filled style={{ color: "#1DB954" }} />
          <FormattedMessage id="registration-confirmed.title" defaultMessage="Registration Confirmed" />
        </div>
      }
      actions={
        !startsInText ? (
          <Button
            appearance="primary"
            onClick={onJoin}
            // icon={<EnterIcon />}
          >
            <FormattedMessage id="registration-confirmed.join" defaultMessage="Continue" />
          </Button>
        ) : null
      }
    >
      {startsInText ? (
        <Text>
          <FormattedMessage
            id="registration-confirmed.starts-in"
            defaultMessage="The activation starts in {time}. We'll email you reminders and registration details before the activation starts."
            values={{ time: startsInText }}
          />
        </Text>
      ) : (
        <Text>
          <FormattedMessage
            id="registration-confirmed.message"
            defaultMessage="Thank you for registering for the activation <b>{eventName}</b>. We've sent an email to <b>{email}</b> with the registration details."
            values={{
              eventName,
              email: userEmail,
              b: chunks => <strong>{chunks}</strong>
            }}
          />
        </Text>
      )}
    </Modal>
  );
};

RegistrationConfirmedDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  eventName: PropTypes.string,
  userEmail: PropTypes.string,
  startsInText: PropTypes.string,
  onJoin: PropTypes.func
};

export default RegistrationConfirmedDialog;
